// sharedState.js
const state = {
  replyBoxMessage: '',
};

const mutations = {
  SET_REPLY_BOX_MESSAGE($state, message) {
    $state.replyBoxMessage = message;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
